<div class="pickup-for-filter">
    <div class="pickup-for-filter__inner" [ngClass]="{'is-disabled': !(hasLocations$ | async)}">
        <shared-pickup-label [disabled]="!(hasLocations$ | async)" (onClick)="onLabelClick($event)" [title]="labelTitle"
            [mode]="mode">
        </shared-pickup-label>

        <shared-pickup-asap [disabled]="!(hasLocations$ | async)" (onClick)="onAsapClick($event)" [title]="asapTitle"
            [mode]="mode" [isActive]="(currentMode$ | async)?.Id === 1" [hidden]="(filters$ | async)?.pickupTime?.Id">
        </shared-pickup-asap>

        <div class="pickup-for-filter__collapse">
            <div class="pickup-for-filter__select" *ngIf="!(isHiding$ | async)" directive-side-collapse="right"
                [isCollapsed]="!(filters$ | async)?.pickupTime?.Id && (filters$ | async)?.pickupMode?.Id !== 2">
                <span class="pickup-for-filter__separator" [hidden]="(filters$ | async)?.pickupTime?.Id">/</span>

                <div class="pickup-for-filter__options">
                    <shared-pickup-later [labelType]="pickupLabelType" [isSchedule]="futureOrders"
                        [disabled]="!(hasLocations$ | async)" (onDropdownToggle)="dropdownToggle($event)"
                        [isActive]="(currentMode$ | async)?.Id === 2" (onDropdownSelected)="dropdownSelected($event)"
                        [title]="laterTitle" [mode]="mode" [selected]="selected$ | async" [options]="options$ | async"
                        [dropdownWidth]="dropdownWidth">
                    </shared-pickup-later>
                </div>
            </div>

            <shared-pickup-next [disabled]="!(hasLocations$ | async)" (onClick)="onNextClick($event)" icon="next"
                [mode]="mode" [hidden]="(filters$ | async)?.pickupTime?.Id || (filters$ | async)?.pickupMode?.Id === 2">
            </shared-pickup-next>
        </div>

    </div>
</div>